import { render } from "./PrevAdminLoadBulkDialog.vue?vue&type=template&id=7c0baf6b"
import script from "./PrevAdminLoadBulkDialog.vue?vue&type=script&lang=js"
export * from "./PrevAdminLoadBulkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__